/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartLineH = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7.186 1.419 8.814 2.58 4.239 8.984l5.964 7.954-3.346 5.576-1.714-1.028 2.653-4.425-6.035-8.047zm6 0 1.628 1.162-4.575 6.403 5.964 7.954-3.346 5.576-1.714-1.028 2.653-4.425-6.035-8.047zm6 0 1.628 1.162-4.575 6.403 5.964 7.954-3.346 5.576-1.714-1.028 2.653-4.425-6.035-8.047z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartLineH as ChartLineH };
